<template>
  <v-data-iterator
    :items="value"
    item-key="anneeUniv"
    disable-sort
    hide-default-footer
    dense
  >
    <template v-slot:header>
      <v-row dense>
        <v-col cols="12" md="2" class="elevation-2">Cursus POST-BAC</v-col>
      </v-row>
    </template>
    <template v-slot:default="{ items }">
      <v-row dense v-for="(item, index) in value" :key="index">
        <v-col cols="12" md="2" class="font-weight-light">
          <span class="elevation-1">{{ item.libelleAnneeUniv }}</span>
          <span v-if="!isRowValid(index)" class="red--text text-caption">
            <br />Ligne incomplète
          </span>
        </v-col>
        <v-col cols="12" md="4" offset="1" offset-md="0">
          <v-text-field
            v-model="item.cursus"
            label="Formation suivie"
            title="ex: Licence de psychologie"
            placeholder="ex: Licence de psychologie"
            dense
            @input="resetValidRow(index, 'cursus')"
            :error-messages="checkApiErrors('cursus')"
            :rules="cursusRules"
          >
            ></v-text-field
          >
        </v-col>
        <v-col cols="6" md="2" offset="1" offset-md="0">
          <v-select
            v-model="item.niveau"
            label="Niveau"
            :items="niveaux"
            item-value="id"
            item-text="libelle"
            dense
            @change="resetValidRow(index, 'niveau')"
            :error-messages="checkApiErrors('niveau')"
          ></v-select>
        </v-col>
        <v-col cols="4" md="1" offset="1" offset-md="0" class="text-center">
          <v-badge color="grey" content="Validée ?" offset-x="50" offset-y="20">
            <v-checkbox v-model="item.validation" dense></v-checkbox>
          </v-badge>
        </v-col>
        <v-col cols="12" md="3" offset="1" offset-md="0">
          <v-text-field
            v-model="item.etablissement"
            label="Établissement"
            title="ex: Université de Caen - 14 Calvados"
            placeholder="ex: Université de Caen - 14 Calvados"
            dense
            @input="resetValidRow(index, 'etablissement')"
            :error-messages="checkApiErrors('etablissement')"
            :rules="etablissementRules"
          >
            ></v-text-field
          >
        </v-col>
      </v-row>
    </template>
  </v-data-iterator>
</template>

<script>
import BaseForm from "@/components/base/BaseForm";

export default {
  name: "EditCursusPostBac",
  extends: BaseForm,
  props: {
    value: {
      type: Array,
      required: true
    },
    maxRows: Number
  },

  data() {
    return {
      niveaux: [
        { id: "", libelle: "" },
        { id: "BAC+1", libelle: "BAC+1" },
        { id: "BAC+2", libelle: "BAC+2" },
        { id: "BAC+3", libelle: "BAC+3" },
        { id: "BAC+4 ou plus", libelle: "BAC+4 ou plus" }
      ],
      cursusRules: [
        v =>
          !v ||
          (v && v.length >= 5) ||
          "La formation suivie doit contenir au minimum 5 caractères"
      ],
      niveauRules: [
        v =>
          !v ||
          (v && v.length >= 2) ||
          "Le niveau doit contenir au minimum 2 caractères"
      ],
      etablissementRules: [
        v =>
          !v ||
          (v && v.length >= 4) ||
          "L'établissement doit contenir au minimum 4 caractères"
      ],
      validPostBac: []
    };
  },
  created() {
    this.initValidPostBac();
  },
  methods: {
    initValidPostBac() {
      for (let i = 0; i < this.maxRows; i++) {
        this.validPostBac[i] = true;
      }
    },
    isRowValid(index) {
      return this.validPostBac[index];
    },
    resetValidRow(indexRecord, field) {
      const ligne = this.value[indexRecord];
      if (
        (ligne.cursus.length === 0 &&
          ligne.niveau.length === 0 &&
          ligne.etablissement.length === 0) ||
        (ligne.cursus.length > 0 &&
          ligne.niveau.length > 0 &&
          ligne.etablissement.length > 0)
      ) {
        this.$set(this.validPostBac, indexRecord, true);
      } else {
        this.$set(this.validPostBac, indexRecord, false);
      }
      this.$emit("validRow", this.validPostBac);
      this.resetApiErrors(field);
    }
  }
};
</script>
